import React from "react";
import  { useState, useEffect } from 'react';
import './classes/BasketballEducationProgram.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';

const BasketballEducationProgram = () => {

    // const navigate = useNavigate();
    // const app_url = configData.APP_URL;
   const [isLoading, setIsLoading] = useState(true);
   const [mentors, setMentors] = useState([]);
   const [courseTopics, setCourseTopics] = useState([]);
   const [testimonialsData, setTestimonialsData] = useState([]);

    useEffect(() => {
        const mentors = [
             {
                name: "Mark Warkentien",
                image: "/basic/web/images/scout/picture-1960-1441822900.jpg",
                description: ` is the New York Knicks Director of Player Personnel. Formerly, Mark was the Denver Nugget's General Manager and awarded the 2009 NBA Executive of the Year. Mark worked for one season as the Director of Player Personnel for the Cleveland Cavilers. Prior to Cleveland, Mark headed up the Portland Trail Blazers Scouting Department for ten years as Assistant General Manager and Director of Scouting. Mark earned his Masters in Sports Leadership from Concordia University Chicago and teaches Basketball GM & Scouting.`,
               
             },
             {
                name: "Dean Oliver",
                image: "/basic/web/images/scout/picture-1959-1441823044.jpg",
                description: ` is currently a Statistical Analyst and Scout for the NBA Denver Nuggets, and formerly with the NBA Seattle Supersonics as a Statistical Analyst. Dean is the author of "Basketball on Paper" and an expert at the evaluation of assembling players into a team, including quantitative evaluations of player quality, game strategy, and team chemistry. Dean is a "guru" of basketball statistics, having received a Ph.D. in statistics from the University of North Carolina.`,
               
             },
            
        ];
        setMentors(mentors);

        const courseTopics = [
            "Basketball Scouting player evaluation; body type, mental makeup, playing ability, physical tools",
            "Learn to identify players who will succeed at NBA or  various international levels",
            "College Scouting and rating college talent as it pertains to the NBA draft",
            "Traditional basketball scouting vs. new high tech scouting and digital video editing",
            "The making of a basketball scouting report",
            "Basketball Scouting, player evaluation, player ratings and in-depth analysis",
            "Concise and indepth Basketball scouting terminology",
            "Collegiate basketball scouting versus high school players",
            "Methods of ranking high-school and college basketball talent",
            "The language and history of basketball scouting",
            ];
        setCourseTopics(courseTopics);

           const initialTestimonials  = [
        {
            id: 1,
            name: "David Sauriol",
            title: "SMWW / NetScouts Apprentice",
            image:
            "/basic/web/images/scout/picture-569910-1549563297.jpg",
            link: "/testimonial/david-sauriol",
            body: `For those interested in getting experience in scouting, I fully endorse the SMWW/ Netscouts apprenticeship. One thing that holds people back from their dreams of working in professional basketball is actually getting the real work experience. Other SMWW classes allow aspiring basketball professionals to learn specific skills this program allows you to actually apply them.  The media access that this apprenticeship provides is the real cherry on top, it gave me just what I needed, more access to the Raptor 905. `
        }
        ];
   setTestimonialsData(initialTestimonials);

    },[]);

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
    
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="basketball-education-progarm-main">
                <Helmet><title>Basketball Scout Education</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                   <div className="basketball-education-progarm-container">
                    <div className="scouting-mentors">                        
                            <h1>SMWW Basketball Education Program</h1>
                            <p>SMWW Basketball Scouts have been trained and mentored by some of the best in the industry. SMWW Basketball Scouts have completed a rigorous eight week training program and instructed by Mark Warkentien and Dean Oliver. SMWW Basketball Scouts are listed here with scouting report samples. Please contact them and arrange a complimentary scouting report for your program, be it at the high school, university, or professional level.</p>
                            <h2>SMWW Basketball Scouting Mentors:</h2>
                             {mentors.map((mentor,index) => (
                                <div className="scout-mentors" key={mentor.name} style={{ marginBottom: "1.5rem", overflow: "auto" }}>
                                <img
                                    src={mentor.image}
                                    alt={mentor.name}
                                    className={`mentor-image mentor-image-${index}`}
                                />
                                <p>
                                    <strong>{mentor.name}</strong> {mentor.description}
                                </p>
                                </div>
                            ))}
                            <h2>SMWW Basketball Scouts have successfully completed 8 weeks of training including:</h2>
                                <ul>
                                    {courseTopics.map((topic, index) => (
                                    <li key={index}>{topic}</li>
                                    ))}
                                </ul>
                               <div style={{ clear: "both", textAlign: "center", marginBottom: "10px" }}>
                                <a className="reddbtnn" href="http://www.sportsmanagementworldwide.com/application">
                                Apply today for training as an SMWW Certified Basketball Scout
                                </a>
                               </div>
                            <p>
                                <p>&nbsp;</p>
                            <span><strong><a href="/sports/basketball">Click here</a>  to search for a SMWW Basketball Scout by Area.  </strong><br/>
                            SMWW Scouts will do a complimentary scouting report to your specifications to prove they are an expert.</span></p>
                            <p><strong><em>SMWW Scouts will be an exceptional resource to save you time and money in your program!</em></strong></p>
                    </div>
                  
                    </div>
                </div>
                <div className="right basketball-education-right">
                     <div id="block-views-testimonials-block" className="block block-views">
                    <h2>Testimonials:</h2>

                  <div className="">
                        <div className="view view-testimonials">
                        <div className="">
                            <div className="testimonial-wrapper">
                            <ul>
                                {testimonialsData.map((testimonial) => (
                                <li
                                    key={testimonial.id}
                                    className="views-row"
                                >
                                    <div className="desktop_testimonials">
                                    <div className="views-field views-field-field-image">
                                        <div className="field-content">
                                        <img
                                            className="lazyloaded"
                                            src={testimonial.image}
                                            alt={testimonial.name}
                                            style={{ width: "100px", height: "100px" }}
                                        />
                                        </div>
                                    </div>

                                    <div className="views-field views-field-title title">
                                        <span className="field-content">
                                        <a href={testimonial.link}>{testimonial.name}</a>
                                        </span>
                                    </div>

                                    <div className="views-field views-field-field-author-title text">
                                        <div className="field-content">{testimonial.title}</div>
                                    </div>

                                    <div className="views-field views-field-body">
                                        <div className="field-content">
                                        <p>{testimonial.body}</p>
                                        </div>
                                    </div>
                                    </div>

                                   

                                    <div className="mobile_testimonials">
                                    <div className="views-field views-field-field-image">
                                        <div className="field-content">
                                        <img
                                            className="lazyload testimonial_mobile_image"
                                            src={testimonial.image}
                                            alt={testimonial.name}
                                        />
                                        </div>
                                    </div>

                                    <div className="testimonial_wrapper_mobile">
                                        <div className="testimonial_left_content">
                                        <div className="testimonial_title">
                                            <a href={testimonial.link}>{testimonial.name}</a>
                                        </div>
                                        <br />
                                        <div className="testimonial_tag_line">
                                            {testimonial.title}
                                        </div>
                                        </div>
                                        <div className="testimonial_right_content">
                                        <div className="testimonial_body_content">
                                            <p>{testimonial.body}</p>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </li>
                                ))}
                              
                            </ul>
                            </div>
                        </div>
                        </div>
                    </div>
                   

                    </div>
                </div>
            </div>
        )}
        </>
    );
};
export default BasketballEducationProgram;